import React, { useContext, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import {
  Box,
  Container,
  makeStyles,
  Typography,
  Grid,
  Paper,
  Divider
} from '@material-ui/core';
import Page from 'src/components/Page';

import Input from '../../../shared/component/FormElements/Input';
import Button from '../../../shared/component/FormElements/Button';
import Seletor from '../../../shared/component/FormElements/Seletor';
import Avatar from '../../../shared/component/FormElements/Avatar';
import ErrorMessage from '../../../shared/component/UIElements/ErrorMessage';
import LoadingSpinner from '../../../shared/component/UIElements/LoadingSpinner';
import {
  VALIDATOR_EMAIL,
  VALIDATOR_REQUIRE,
  VALIDATOR_MINLENGTH
} from '../../../utils/validators';
import { useForm } from '../../../hooks/form-hook';
import { useHttpClient } from '../../../hooks/http-hook';
import { AuthContext } from '../../../shared/context/auth-context';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  titulo: {
    color: '#3A3A3A',
    fontWeight: 700,
    fontSize: '24px',
    marginBottom: '15px'
  },
  button: {
    marginTop: '15px',
    display: 'block',
    color: 'white',
    borderRadius: '23px',
    WebkitBorderRadius: '23px',
    MozBorderRadius: '23px'
  }
}));

const Novo = () => {
  const classes = useStyles();
  const auth = useContext(AuthContext);
  const [permissoes, setPermissoes] = useState([]);
  const [navegar, setNavegar] = useState(false);
  const {
    isLoading,
    error,
    sendRequest,
    clearError
  } = useHttpClient();
  const [formState, inputHandler] = useForm({
    email: {
      value: '',
      isValid: false
    },
    avatar: {
      value: '',
      isValid: true
    },
    nome: {
      value: '',
      isValid: false
    },
    permissao: {
      value: '',
      isValid: false
    },
  }, false);
  const novoSubmitHandler = async (event) => {
    event.preventDefault();
    try {
      const formulario = new FormData();
      formulario.append('nome', formState.inputs.nome.value);
      formulario.append('email', formState.inputs.email.value);
      formulario.append('senha', formState.inputs.senha.value);
      formulario.append('permissao', formState.inputs.permissao.value);
      formulario.append('avatar', formState.inputs.avatar.value);
      const response = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/usuarios`,
        'POST',
        formulario,
        {
          'x-access-token': auth.token
        }
      );
      console.log(response);
      if (response.sucesso) {
        setNavegar('app/usuarios/');
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    const fetchPermissoes = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_URL}/usuarios/permissoes`,
          'GET',
          null,
          {
            'Content-Type': 'application/json',
            'x-access-token': auth.token
          }
        );
        console.log(responseData);
        setPermissoes(responseData.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchPermissoes();
  }, [sendRequest, auth]);

  if (navegar) {
    return <Navigate to={`/${navegar}`} />;
  }
  return (
    <Page
      className={classes.root}
      title="Adicionar Novo Usuário"
    >
      <Container maxWidth="md">
        <Paper p={3} style={{ padding: '15px' }}>
          <Box mt={3}>
            <form onSubmit={novoSubmitHandler}>
              <Box my={2}>
                <Typography
                  color="textPrimary"
                  align="left"
                  variant="h2"
                  className={classes.titulo}
                >
                  Cadastrar novo Usuário
                </Typography>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Avatar
                      id="avatar"
                      name="avatar"
                      onInput={inputHandler}
                      validators={[]}
                      initialValid
                      initialValue=""
                      errorText="Insira o avatar do usuário."
                      label="Avatar do Usuário"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Input
                      id="nome"
                      element="input"
                      type="text"
                      label="Nome do Usuário"
                      fullWidth
                      validators={[VALIDATOR_REQUIRE()]}
                      errorText="Insira um nome."
                      onInput={inputHandler}
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Input
                      id="email"
                      element="input"
                      type="email"
                      label="E-mail do Usuário"
                      fullWidth
                      validators={[VALIDATOR_EMAIL()]}
                      errorText="Insira um e-mail válido."
                      onInput={inputHandler}
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Input
                      id="senha"
                      element="input"
                      type="password"
                      label="Senha do Usuário"
                      fullWidth
                      validators={[VALIDATOR_REQUIRE(), VALIDATOR_MINLENGTH(7)]}
                      errorText="Insira uma senha para o Usuário com no mínimo 7 dígitos."
                      onInput={inputHandler}
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Seletor
                      id="permissao"
                      name="permissao"
                      onInput={inputHandler}
                      label="Permissão do Usuário"
                      placeholder="Permissão do Usuário"
                      blank="Selecione a Permissão do Usuário"
                      fullWidth
                      variant="outlined"
                      data={permissoes.map((perm) => {
                        return { label: perm.nome, id: perm._id };
                      })}
                      errorText="Informe a permissão do Usuário."
                      validators={[VALIDATOR_REQUIRE()]}
                    />
                  </Grid>
                </Grid>
                <Divider variant="middle" style={{ margin: '30px 0px' }} />
                <Button
                  color="secondary"
                  disabled={!formState.isValid}
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                  marginBottom={5}
                  classes={classes.button}
                >
                  Salvar Usuário
                </Button>
              </Box>
              {isLoading && <LoadingSpinner asOverlay />}
              <ErrorMessage error={error} onClear={clearError} />
            </form>
          </Box>
        </Paper>
      </Container>
    </Page>
  );
};
export default Novo;
